import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { format } from 'date-fns';
import { clone } from 'ramda';
import { WEEK_DAYS, formatAMPM, getDateAsIsoString, getPrettyStringDate, getDateWithDelayInDays, getCurrentDateAsHoursAMPM, getCurrentDateAsMinutesAMPM, getHoursAndMinutesFromAMPM, getCurrentDateAsMinutes, parseToUTCDate, getDayDateAtNight, } from '@/helpers/dates';
let DateMixin = class DateMixin extends Vue {
    get baseFormat() {
        return `E, dd MMM yyyy HH:mm:ss`;
    }
    getDate({ delta = 0, date }) {
        const localDate = date ? new Date(date.toString()) : new Date();
        localDate.setDate(localDate.getDate() + delta);
        return localDate;
    }
    getDay(date) {
        return date.getDate();
    }
    getWeekDayMame(date) {
        return WEEK_DAYS[date.getDay()];
    }
    getDateAsIsoString(date) {
        return getDateAsIsoString(date);
    }
    getPrettyStringDate(date) {
        return getPrettyStringDate(date, this.$i18n);
    }
    getDateWithDelayInDays(date, delay) {
        return getDateWithDelayInDays(date, delay);
    }
    getDayDateAtNight(date) {
        return getDayDateAtNight(date);
    }
    getCurrentDateAsHoursAMPM(date, useUTC = false) {
        return getCurrentDateAsHoursAMPM({ date, locale: this.$i18n.locale, useUTC });
    }
    getCurrentDateAsMinutesAMPM(date, useUtc = true) {
        return getCurrentDateAsMinutesAMPM({ date, locale: this.$i18n.locale, useUTC: useUtc });
    }
    getCurrentDateAsMinutes(date, useUtc = true) {
        return getCurrentDateAsMinutes({ date, locale: this.$i18n.locale, useUTC: useUtc });
    }
    formatAMPM(date, useUTC = true) {
        return formatAMPM({ date, locale: this.$i18n.locale, useUTC });
    }
    formatDateAsString(date) {
        return format(date, this.baseFormat);
    }
    getHoursAndMinutesFromAMPM(ampm) {
        // @ts-ignore-next-line
        return getHoursAndMinutesFromAMPM(ampm);
    }
    parseToUTCDate(dateAsString) {
        return parseToUTCDate(dateAsString);
    }
    getDayDateNearNight(date) {
        const localDate = date ? clone(date) : new Date();
        localDate.setHours(23, 59, 0, 0);
        return localDate;
    }
    getDayDateNearMorning(date) {
        const localDate = date ? clone(date) : new Date();
        localDate.setHours(0, 0, 1, 0);
        return localDate;
    }
};
DateMixin = __decorate([
    Component
], DateMixin);
export default DateMixin;
;
